import * as React from "react";
import { observable, action, computed } from "mobx";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class SidebarButton extends Button {

	@observable on = false;
	timeoutId: number;

	componentDidMount() {
		this.installTimer();
	}

	componentDidUpdate() {
		if (this.timeoutId) {
			this.uninstallTimer();
			this.installTimer();
		}
	}

	componentWillUnmount() {
		this.uninstallTimer();
	}

	installTimer() {
		this.timeoutId = window.setInterval(() => { this.updateStatus() }, 1000);
	}

	uninstallTimer() {
		if (this.timeoutId) {
			window.clearInterval(this.timeoutId);
			this.timeoutId = null;
		}
	}

	updateStatus() {
		let asideButton = document.getElementById("cusSidebarToggle");
		if (asideButton && asideButton.classList.contains("loaded")) {
			this.on = asideButton.classList.contains("is--button-highlight");
			this.uninstallTimer();
		}
	}

	@action onClick() {
		let asideButton = document.getElementById("cusSidebarToggle");
		this.on = asideButton.classList.contains("is--button-highlight");
	}

	@computed get tooltip() {
		return this.on ? Strings.reader.readerAreaAsideButtonExpandedTooltip : Strings.reader.readerAreaAsideButtonCollapsedTooltip;
	}

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : this.tooltip} onClick={this.onClick.bind(this)}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M30,6V26H2V6H30m2-2H0V28H32V4h0Z" />
					<rect x="4" y="8" width="8" height="16" />
				</svg>
			</i>
		</Button>;
	}
}
